<template>
  <div class="drawer">
    <div class="user-avatar">
      <div class="avatar-details">
        <h5>Smart Invoice</h5>
        <p>Portal</p>
      </div>
    </div>
    <div class="accordion menu" id="accordionPanelsStayOpenExample">
      <div class="accordion-body">
        <router-link class="route-btn w-100 bg-transparent" :to="{ name : 'QueryLogs'}">
          <font-awesome-icon class="icon" icon="home"/>
          Dashboard
        </router-link>
      </div>
      <div class="accordion-body">
        <router-link class="route-btn w-100 bg-transparent" :to="{ name : 'stock'}">
          <font-awesome-icon class="icon" icon="boxes-stacked"/>
          Stock
        </router-link>
      </div>

      <div class="accordion-body">
        <router-link class="route-btn w-100 bg-transparent" :to="{ name : 'import'}">
          <font-awesome-icon class="icon" icon="fa-solid fa-computer"/>
          Imports
        </router-link>
      </div>

      <div class="accordion-body">
        <router-link class="route-btn w-100 bg-transparent" :to="{ name : 'DepartmentConfig'}">
          <font-awesome-icon class="icon" icon="boxes-stacked"/>
          Department Config
        </router-link>
      </div>

      <div class="accordion-body">
        <router-link class="route-btn w-100 bg-transparent" :to="{ name : 'currency-config'}">
          <font-awesome-icon class="icon" icon="fa-gears"/>
          Currency Configuration
        </router-link>
      </div>

      <div class="accordion-body">
        <router-link class="route-btn w-100 bg-transparent" :to="{ name : 'country-config'}">
          <font-awesome-icon class="icon" icon="fa-gears"/>
          Country Configuration
        </router-link>
      </div>

      <div class="accordion-body">
        <router-link class="route-btn w-100 bg-transparent" :to="{ name : 'GRV'}">
          <font-awesome-icon class="icon" icon="fa-money-bill"/>
            GRV
        </router-link>
      </div>

      <div class="accordion-body">
        <router-link class="route-btn w-100 bg-transparent" :to="{ name : 'UserManagment'}">
          <font-awesome-icon class="icon" icon="fa-gears"/>
          User Management
        </router-link>
      </div>

      <div class="accordion-body" v-if="!isOnlineVsdc">
        <router-link class="route-btn w-100 bg-transparent" :to="{ name : 'settings'}">
          <font-awesome-icon class="icon" icon="fa-gears"/>
            Settings
        </router-link>
      </div>

      <div class="accordion-body">
        <a class="route-btn w-100 bg-transparent" @click="userLogout">
          <font-awesome-icon class="icon" icon="fa-solid fa-lock"/>
          User Logout
        </a>
      </div>

    </div>
  </div>

</template>
<script>
export default {
  computed: {
    // Expose global Online VSDC toggle as a simple computed flag
    isOnlineVsdc() { return window.isOnlineVsdc === true; }
  },
  methods : {
    userLogout(){
      return Swal.fire({
        icon : `question`,
        title : `Are you sure?`,
        text : `you will be logged out`,
        showCancelButton : true,
      }).then((res)=>{
        localStorage.removeItem('auth');
        // Keep Api-key persisted across logout per requirement
        localStorage.removeItem('session-id');
        if (res.isConfirmed) return this.$router.push({ name : `Login` })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.accordion-body {
  padding: 0; /* Remove padding from accordion-body */
  margin: 0; /* Remove margin from accordion-body */
}
a {
  &:hover, &.a-exact-active {
    background: #f1f1f1;
    color: #3F8DCD;

    .icon {
      color: #3F8DCD;
    }
  }
}

.warning {
  border-radius: 50%;
  display: inline-flex; /* Ensures that the container can shrink to fit its content */
  align-items: center; /* Center the content vertically */
  justify-content: center; /* Center the content horizontally */
  box-shadow: 0 0 0 9px rgba(217, 193, 98, 0); /* Starting with transparent box-shadow */
  transform: scale(1);
  animation: pulse 2s infinite;
  transform-origin: center center; /* Ensures transform scales from the center */
}

@keyframes pulse {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 9px rgba(217, 193, 98, 1); /* Fully opaque at start */
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 19px rgba(217, 193, 98, 0); /* Fully transparent and expanded shadow */
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 9px rgba(217, 193, 98, 1); /* Return to start */
  }
}

.disabled {
  pointer-events: none;
  display: none;
}

.drawer {
  width: 100%;
  background: white;
  height: 100%;
  overflow-y: auto;

  .user-avatar {
    display: inline-flex;
    width: 100%;
    background: url('/src/assets/img/play-banner.png') fixed;
    background-size: cover;
    color: white;
    min-height: 140px;
    background-color: rgba(50, 70, 80, 0.7);
    background-blend-mode: soft-light;

    .avatar {
      background: #40434A;
      min-width: 80px;
      width: 80px;
      height: 80px;
      border-radius: 50%;
    }

    .avatar-details {
      width: 100%;
      padding: 5px 5px 5px 10px;
      display: flex;
      flex-direction: column;
      align-items: start;
      justify-content: center;

      h5, p {
        margin: 0;
      }

      p {
        font-size: 15px;
        color: #ffffff;
        font-weight: 400;

        &:nth-child(3) {
          color: #15356E;
          font-weight: 600;
        }
      }

    }
  }
}

.menu {
  text-align: center;

  span {
    font-family: "Inter", sans-serif;
    font-size: 15px;
    font-weight: bold;
  }
}

.last-upd {
  font-weight: bold;
}

.icon {
  margin-right: 10px;
  color: #606d77;
  font-size: 1.5rem;
}

.route-btn {
  height: 50px; /* Adjust the height to reduce spacing */
  padding: 0 10px; /* Reduce padding */
  display: flex;
  flex-direction: row;
  align-items: center;
  font-weight: 600;
  text-decoration: none;
  color: #1c1c1c;
  margin-bottom: 5px; /* Add a small margin to separate the buttons */
}

#footer {
  bottom: 0;
  position: fixed;
  width: 100%;
}

.not-footer {
  //margin-bottom: 100px;
}

.box-container {
  display: flex;
  justify-content: center; /* Center contents horizontally */
  //margin-bottom: 10px;
}

.red-background-blink {
  background-color: red;
  animation: blink 1s infinite;
  padding: 10px 20px; /* Adjust height and width */
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
}

.box {
  display: inline-block;
}

.text-white {
  color: white;
}

@keyframes blink {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}

</style>

